// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PU9kE","top":"styles_top__1IfuU"};